// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden[data-v-38f73197] {\n  display: none;\n}\n.pageAlign[data-v-38f73197]{\n  float:right;\n}\n", ""]);
// Exports
module.exports = exports;
